import { render, staticRenderFns } from "./TelComponent.vue?vue&type=template&id=03803199&"
import script from "./TelComponent.vue?vue&type=script&lang=ts&"
export * from "./TelComponent.vue?vue&type=script&lang=ts&"
import style0 from "./TelComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports